<template>
    <div>
        <div class="columns">
            <div class="field column">
                <label class="label is-uppercase mt-3 ml-3">Vorname</label>
                <div class="control">
                    <input class="input" type="text" placeholder="Text input" />
                </div>
            </div>
            <div class="field column">
                <label class="label is-uppercase mt-3 ml-3">Nachname</label>
                <div class="control">
                    <input class="input" type="text" placeholder="Text input" />
                </div>
            </div>
            <div class="field column">
                <label class="label is-uppercase mt-3 ml-3">Label</label>
                <div class="control">
                    <input class="input" type="text" placeholder="Text input" />
                </div>
            </div>
        </div>
        <div class="field">
            <div class="control">
                <label class="radio is-uppercase">
                    <input type="radio" name="answer1" />
                    mm
                </label>
                <label class="radio is-uppercase">
                    <input type="radio" name="answer2" />
                    cm
                </label>
                <label class="radio is-uppercase">
                    <input type="radio" name="answer2" />
                    inch
                </label>
            </div>
        </div>
        <div class="field">
            <label class="checkbox">
                <input type="checkbox" />
                abweichend wie Lieferadresse
            </label>
        </div>
        <div class="field">
            <label class="label is-uppercase mt-3 ml-3"
                >Ihre Nachricht an uns</label
            >
            <textarea class="textarea" placeholder="Nachricht"></textarea>
        </div>
        <div class="field">
            <label class="label is-uppercase mt-3 ml-3">Label</label>
            <div class="control">
                <input class="input" type="text" placeholder="Text input" />
            </div>
            <button class="button is-primary-dark">Button</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TextField.vue',
};
</script>

<style lang="scss" scoped>
.input {
}
</style>
